<div class="div-n-found">
  <!-- <button mat-raised-button color="primary"  (click)="goToSub()">Subscription Expired</button> -->
  <div >
    @if (!isFromDialog) {
      <ion-header [translucent]="true" class="ion-no-border">
        <div color="color1" class="dialog-header">
          <!-- <ion-buttons slot="start" style="color: white;">
          <ion-menu-button></ion-menu-button>
        </ion-buttons> -->
        <ion-row style="padding-top: 8px;
        padding-left: 12px;
        padding-right: 6px;">
          <ion-col size="8.5"> <ion-title class="title" style="text-align: left;">Expired</ion-title></ion-col>
          <ion-col size="3.5" style="text-align: end;"> <ion-icon style="color: white;font-size: 25px;"
          name="close-outline" (click)="closeDialog()"></ion-icon></ion-col>
        </ion-row>
      </div>
    </ion-header>
  }
  <ion-grid>
    <ion-row style="margin-bottom: 10px;">
      <ion-col size="3">
        <ion-icon style="font-size: 70px;color: #e35655;" name="alert-circle-outline"></ion-icon>

      </ion-col>
      <ion-col size="9" >
        <h3 style="color: #e35655;">YOUR SUBSCRIPTION IS EXPIRED!</h3>
        <h4 style="color: #777777;">Feel free to upgrade to our premium plan to get more additional features.</h4>

      </ion-col>
    </ion-row>
    <div style="width: 100%;text-align: center; margin-bottom: 15px;">

      <button class="button" (click)="goToSub()">Subscribe Now</button>
    </div>
  </ion-grid>
</div>
</div>